import { Injectable } from '@angular/core';
import { Observable, Subscriber, Subscription } from 'rxjs';
import { ApiService } from '../base/api.service';
import { ApiEndpointsService } from '../base/api-endpoints.service';
import { ServerResponse } from '../../interfaces/base/server.response';
import { WasteData } from '../../interfaces/waste-calendar/waste-data';

@Injectable()

export class WasteDataService {

  constructor(private api: ApiService,
              private apiEndpoints: ApiEndpointsService,
  ) {
  }

  all(): Observable<WasteData[] | boolean> {
    return new Observable<WasteData[] | boolean>((o: Subscriber<WasteData[] | boolean>) => {
      const subscription: Subscription = this.api.get(this.apiEndpoints.get('waste-calendar.waste-data.index'))
        .subscribe((response: ServerResponse): void => {
          if (typeof response.data !== 'undefined') {
            o.next(<WasteData[]>response.data);
          } else {
            o.next(false);
          }
        }, (): void => o.next(false));

      return (): void => {
        subscription.unsubscribe();
      };
    });
  }

  import(formData: any): Observable<ServerResponse> {
    return this.api.post(this.apiEndpoints.get('waste-calendar.waste-data.import'), formData);
  }

  setActive(id: number): Observable<boolean> {
    return new Observable<boolean>((o: Subscriber<boolean>) => {
      const subscription: Subscription = this.api.get(this.apiEndpoints.get('waste-calendar.waste-data.set-active', {':id': id}))
        .subscribe((response: ServerResponse): void => {
            if (response) {
              o.next(true);
            } else {
              o.next(false);
            }
          },
          (): void => o.next(false));

      return (): void => {
        subscription.unsubscribe();
      };
    });
  }

  export(id: number): Observable<ServerResponse> {
    return this.api.export(this.apiEndpoints.get('waste-calendar.waste-data.export', {':id': id}));
  }

  delete(id: number): Observable<boolean> {
    return new Observable<boolean>((o: Subscriber<boolean>) => {
      const subscription: Subscription = this.api.delete(this.apiEndpoints.get('waste-calendar.waste-data.delete', {':id': id}))
        .subscribe((response: ServerResponse): void => {
            if (response) {
              o.next(true);
            } else {
              o.next(false);
            }
          },
          (): void => o.next(false));

      return (): void => {
        subscription.unsubscribe();
      };
    });
  }
}
